export default __webpack_public_path__ + "static/media/learn-ask-alex.e98e0553.jpg";